import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, TextField } from '@material-ui/core';
import Popup from 'components/popup/popup';
import { UPDATE_EMAIL_TEMPLATE } from 'store/key';
import { useDispatch } from 'react-redux';
import useDialog from 'components/ConfirmDialog/useDialog';
import { emptyShow } from 'utility/general';
import { EMAIL_TEMPLATE_CREATED } from 'utility/frontendMessage';

const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 'bold',
    },
    item: {
        marginTop: theme.spacing(2),
    },
}));

export default function AddEmailDomain(props) {
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const classes = useStyles();
    const rowData = props.rowData ? props.rowData : null;
    const defaultFormData = {
        id: rowData ? rowData.id : 0,
        title: rowData ? rowData.title : '',
        to: rowData ? rowData.to : '',
        cc: rowData ? rowData.cc : '',
        content: rowData ? rowData.content : '',
        status: rowData ? rowData.status : 0,
    };
    const [formData, setFormData] = useState(defaultFormData);

    const handleFormData = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const confirm = () => {
        const data = {
            title: formData.title,
            content: formData.content,
            status: formData.status,
            id: formData.id,
        };

        dispatch({
            type: UPDATE_EMAIL_TEMPLATE,
            payload: {
                row: data,
                callback: () => {
                    showDialog({
                        description: EMAIL_TEMPLATE_CREATED,
                        disableCancelButton: true,
                    });
                    props.getList();
                    props.setOpenPopup(false);
                },
            },
        });
    };
    const cancel = () => {
        props.setOpenPopup(false);
    };
    const reset = () => {
        setFormData(defaultFormData);
    };
    return (
        <Popup
            height="90%"
            width="70%"
            title="Edit Email Template"
            footerActions={[
                { label: 'Cancel', clicked: cancel, color: 'default' },
                { label: 'Reset', clicked: reset },
                { label: 'Confirm', clicked: confirm },
            ]}
            open={props.openPopup}
            closePopup={cancel}
        >
            <Grid container wrap="nowrap" direction="column">
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Title:
                    </Grid>
                    <Grid container item xs={9}>
                        {emptyShow(formData.title)}
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Email Recipients (TO List):
                    </Grid>
                    <Grid container item xs={9}>
                        {emptyShow(formData.to)}
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="center" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Email Recipients (CC List):
                    </Grid>
                    <Grid container item xs={9}>
                        {emptyShow(formData.cc)}
                    </Grid>
                </Grid>
                <Grid container wrap="nowrap" alignItems="flex-start" className={classes.item}>
                    <Grid container item xs={3} className={classes.title}>
                        Content:
                    </Grid>
                    <Grid container item xs={9}>
                        <TextField
                            fullWidth
                            label="Content"
                            multiline
                            rows={20}
                            name="content"
                            value={formData.content}
                            onChange={handleFormData}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Popup>
    );
}
